import * as React from "react";
import { IconComponent, ServiceIcon, Tab, TabHeight, Tabs, TabsLayout, TabsMaxWidth, VehicleIcon } from "../../ui";

export enum VehicleHistoryTab {
  SPECS = "SPECS",
  SERVICES = "SERVICES",
}

export const vehicleHistoryTabId = (tab: VehicleHistoryTab) => `vehicle-history-tab-${tab.toLowerCase()}`;
export const vehicleHistoryPanelId = (tab: VehicleHistoryTab) => `vehicle-history-panel-${tab.toLowerCase()}`;

const options: { key: VehicleHistoryTab; label: string; Icon: IconComponent }[] = [
  { key: VehicleHistoryTab.SPECS, label: "Specs", Icon: VehicleIcon },
  { key: VehicleHistoryTab.SERVICES, label: "Service History", Icon: ServiceIcon },
];

/** Same sizing rules as the parts tabs; capped and centred on wide screens. */
export const VehicleHistoryTabs: React.FC<{
  value: VehicleHistoryTab;
  onChange: (next: VehicleHistoryTab) => void;
}> = ({ value, onChange }) => (
  <Tabs
    value={value}
    onChange={onChange}
    layout={TabsLayout.SCROLLABLE}
    maxWidth={TabsMaxWidth.COMPACT}
    height={TabHeight.COMPACT}
    aria-label="Vehicle history sections"
  >
    {options.map((option) => (
      <Tab
        key={option.key}
        value={option.key}
        id={vehicleHistoryTabId(option.key)}
        aria-controls={vehicleHistoryPanelId(option.key)}
        height={TabHeight.COMPACT}
        label={
          <span className="flex items-center justify-center gap-1 whitespace-nowrap">
            <option.Icon style={{ fontSize: "0.9rem", flexShrink: 0 }} />
            {option.label}
          </span>
        }
        style={{
          fontSize: "0.73rem",
          fontWeight: 600,
          minWidth: 0,
          padding: "0.34rem 0.5625rem",
          textTransform: "none",
          flexGrow: 1,
          flexShrink: 0,
          flexBasis: "auto",
        }}
      />
    ))}
  </Tabs>
);
